import { List, Map, fromJS } from 'immutable';
import { finish as updateCustomer } from './update';

export function request(state, { id, period }) {
    id = parseInt(id, 10);

    let setLimit = state.get('set-limit') || Map();
    let user = setLimit.get(id) || Map();

    user = user.set(
        period,
        (user.get(period) || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0)
    );

    return state.set(
        'set-limit', setLimit.set(id, user)
    );
}

export function error(state, { id, period, errors }) {
    id = parseInt(id, 10);

    let setLimit = state.get('set-limit') || Map();
    let user = setLimit.get(id) || Map();

    user = user.set(
        period,
        (user.get(period) || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(errors))
    );

    return state.set(
        'set-limit', setLimit.set(id, user)
    );
}

export function finish(state, { id, period, customer }) {
    id = parseInt(id, 10);

    let setLimitEl = state.get('set-limit') || Map();
    let userEl = setLimitEl.get(id) || Map();

    userEl = userEl.set(
        period,
        (userEl.get(period) || Map())
            .set('state', 'FINISHED')
            .set('errors', void 0)
    );

    state = state.set('set-limit', setLimitEl.set(id, userEl));

    return customer ? updateCustomer(state, { id, customer }) : state;
}

export function clear(state) {
    return state.set('set-limit', Map());
}
